(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog-zt"]) return;
  try {
    
(() => {
  const grid = document.querySelector('[data-blog-zt-grid]');
  if (!grid) return;

  // sortowanie klienckie: przestawia załadowane karty (nie dociąga nowych)
  document.querySelectorAll('[data-blog-zt-sort]').forEach((btn) => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('[data-blog-zt-sort]').forEach((b) => b.classList.remove('blog-zt-sort-btn--on'));
      btn.classList.add('blog-zt-sort-btn--on');
      const mode = btn.dataset.blogZtSort;
      const cards = Array.from(grid.querySelectorAll('.blog-zt-grid__card'));
      cards
        .sort((a, b) => {
          if (mode === 'long') {
            return (Number(b.dataset.mins) - Number(a.dataset.mins)) || (Number(a.dataset.ord) - Number(b.dataset.ord));
          }
          return Number(a.dataset.ord) - Number(b.dataset.ord);
        })
        .forEach((c) => grid.appendChild(c));
    });
  });

  // „Pokaż więcej" — dociąga kolejną stronę przez Section Rendering API
  const bindMore = (btn) => {
    btn.addEventListener('click', async () => {
      btn.disabled = true;
      try {
        const url = new URL(btn.dataset.nextUrl, window.location.origin);
        url.searchParams.set('section_id', btn.dataset.sectionId);
        const html = await (await fetch(url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('.blog-zt-grid__card').forEach((c) => grid.appendChild(c));
        const nextBtn = doc.querySelector('[data-blog-zt-more]');
        const wrap = btn.closest('.blog-zt-more');
        if (nextBtn) {
          btn.dataset.nextUrl = nextBtn.dataset.nextUrl;
          btn.textContent = `Pokaż więcej (${nextBtn.dataset.remaining})`;
          btn.disabled = false;
        } else {
          wrap.remove();
        }
        const activeSort = document.querySelector('.blog-zt-sort-btn--on[data-blog-zt-sort="long"]');
        if (activeSort) activeSort.click();
      } catch (e) {
        window.location.href = btn.dataset.nextUrl; // awaria fetch → klasyczna paginacja
      }
    });
  };
  document.querySelectorAll('[data-blog-zt-more]').forEach(bindMore);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-bottom-bar"] && !Shopify.designMode) return;
  try {
    
(function() {
  const bar = document.querySelector('[data-sticky-bar]');
  if (!bar) return;
  const showAfter = parseFloat(bar.dataset.showAfter || '60') / 100;
  let ticking = false;
  const update = () => {
    const trigger = window.innerHeight * showAfter;
    if (window.scrollY > trigger) {
      bar.classList.add('sticky-bar--visible');
    } else {
      bar.classList.remove('sticky-bar--visible');
    }
    ticking = false;
  };
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(update);
      ticking = true;
    }
  }, { passive: true });
  update();
})();

  } catch(e) { console.error(e); }
})();
})();
